/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  Form,
  Row,
  Col,
  Input,
  Tooltip,
  DatePicker,
  TreeSelect,
} from 'antd';
import NumericInput from 'components/NumericInput';
import TextArea from 'antd/lib/input/TextArea';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  DESCUENTO_RECURRENTE_Y_VARIABLE,
  DESTINO_DEL_DESCUENTO_PAGO_A_TERCEROS,
  DESTINO_DEL_DESCUENTO_PARA_DEVOLUCION_AL_EMPLEADO,
  ESTATUS_INACTIVO,
  DESCUENTO_UNICOS,
} from 'utils/constants';
import Select from '../../Select';

// eslint-disable-next-line react/prop-types
const DescuentoGenerales = ({
  form,
  estados,
  estatusInactivo,
  estatusAutorizado,
  setConfirmationVisibleEstatus,
  selectedRowKeys,
  acreedores,
  cuentas,
  tiposDeducciones,
  tiposDescuentos,
  destinosDelDescuento,
  fechasDevolucionesEmpleados,
  disabledCampoAcreedores,
  disabledCampoFechaDevolucion,
  aplicaFormatoDeConsulta,
  formatosDeConsultas,
  onChangeAplicaFormatoDeConsulta,
  infoTooltipTipoDescuento,
  getInfoTipoDescuento,
  onChangeTipoDescuento,
  rules,
  setDisableAplicanRangoSalariales,
  setDisableRequiereDatosInformativos,
  onChangeAcreedor,
}) => {
  const [disabledAcreedores, setDisabledAcreedores] = useState(disabledCampoAcreedores);
  const [disabledFechaDevolucion, setDisabledFechaDevolucion] = useState(disabledCampoFechaDevolucion);

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clave"
            rules={rules.clave}
            label="Clave"
            hasFeedback
          >
            <Input
              allowClear
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="clave_anterior"
            label="Clave Anterior"
          >
            <Input
              allowClear
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="concepto"
            rules={rules.required}
            label="Concepto"
            hasFeedback
          >
            <Input
              allowClear
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_de_descuento"
            label={(
              <div style={{ display: 'flex' }}>
                <span>Tipo de Descuento</span>
                <Tooltip title={infoTooltipTipoDescuento} placement="left">
                  <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                </Tooltip>
              </div>
            )}
            rules={rules.required}
            hasFeedback
          >
            <Select
              labelProp="nombre"
              dataSource={tiposDescuentos}
              onChange={(value) => {
                getInfoTipoDescuento(value);
                onChangeTipoDescuento(value);
                if (value === DESCUENTO_RECURRENTE_Y_VARIABLE) {
                  setDisableAplicanRangoSalariales(false);
                } else {
                  setDisableAplicanRangoSalariales(true);
                }
                if (value === DESCUENTO_UNICOS) {
                  setDisableRequiereDatosInformativos(true);
                } else {
                  setDisableRequiereDatosInformativos(false);
                }
              }}
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="destino_del_descuento"
            label="Destino del Descuento"
            hasFeedback
          >
            <Select
              keyProp="descripcion"
              dataSource={destinosDelDescuento}
              onChange={(val) => {
                if (val === DESTINO_DEL_DESCUENTO_PAGO_A_TERCEROS) {
                  setDisabledAcreedores(false);
                  setDisabledFechaDevolucion(true);
                  form.resetFields(['fecha_devolucion_empleado']);
                } else if (val === DESTINO_DEL_DESCUENTO_PARA_DEVOLUCION_AL_EMPLEADO) {
                  setDisabledFechaDevolucion(false);
                  setDisabledAcreedores(true);
                  form.resetFields(['acreedor', 'cuenta_contable']);
                } else {
                  setDisabledAcreedores(true);
                  setDisabledFechaDevolucion(true);
                  form.resetFields(['acreedor', 'cuenta_contable', 'fecha_devolucion_empleado']);
                }
              }}
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="acreedor"
            label="Acreedor para Entregar Descuento"
            hasFeedback
            rules={disabledAcreedores ? null : rules.required}
          >
            <Select
              labelProp="clave"
              keyProp="id"
              dataSource={acreedores}
              onChange={(val) => {
                if (onChangeAcreedor) {
                  onChangeAcreedor(val);
                }
              }}
              disabled={disabledAcreedores || estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={16}>
          <Form.Item
            name="cuenta_contable"
            // rules={rules.required}
            label="Cuenta Contable del Acreedor"
            hasFeedback
          >

            <TreeSelect
              keyProp="clave"
              labelProp="nombre"
              showSearch
              treeNodeFilterProp="title"
              treeData={cuentas}
              disabled
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="tipo_deduccion_nomina"
            label="Concepto de Deducción del SAT"
            rules={rules.required}
            hasFeedback
          >
            <Select
              keyProp="clave"
              labelProp="descripcion"
              keyLabelRender
              dataSource={tiposDeducciones}
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <NumericInput
            name="prioridad_del_descuento"
            label="Prioridad del Descuento"
            rules={rules.entero}
            disabled={estatusInactivo || estatusAutorizado}
          />
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="admite_mas_de_un_descuento_simultaneo"
            label="Admite Más de un Descuento Simultáneo"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="fecha_devolucion_empleado"
            label="Fecha de Devolución al Empleado"
            hasFeedback
            rules={disabledFechaDevolucion ? null : rules.required}
          >
            <Select
              keyProp="descripcion"
              dataSource={fechasDevolucionesEmpleados}
              disabled={disabledFechaDevolucion || estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        {/* <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_formato_de_consulta"
            initialValue={false}
            label="Aplica Formato de Consulta"
            hasFeedback
            rules={rules.required}
          >
            <Select
              onChange={onChangeAplicaFormatoDeConsulta}
              trueFalse
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="formato_de_consulta"
            label="Formato de Consulta"
            hasFeedback
            rules={aplicaFormatoDeConsulta ? rules.required : null}
          >
            <Select
              disabled={!aplicaFormatoDeConsulta || estatusInactivo || estatusAutorizado}
              dataSource={formatosDeConsultas}
              allowClear
            />
          </Form.Item>
        </Col> */}
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="fecha_baja"
            label="Vigencia Final"
          >
            <DatePicker
              placeholder=""
              format="DD/MM/YYYY"
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24}>
          <Form.Item
            name="observaciones"
            label="Observaciones"
            hasFeedback
          >
            <TextArea
              rows={3}
              allowClear
              disabled={estatusInactivo || estatusAutorizado}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="estados_globales"
            label="Estatus"
            rules={rules.estatus}
            hasFeedback
            initialValue={1}
          >
            <Select
              labelProp="descripcion"
              keyProp="id"
              dataSource={estados}
              disabled={!selectedRowKeys.length || estatusInactivo || estatusAutorizado}
              onChange={(val) => {
                if (val === ESTATUS_INACTIVO) {
                  setConfirmationVisibleEstatus(true);
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DescuentoGenerales;
